import {TOOGLE_SIDENAV} from "../actions/app";

const state = {
    isCollapsed: false,
};

const mutations = {
    [TOOGLE_SIDENAV]: (state) => {
        state.isCollapsed = !state.isCollapsed
    },
};

const getters = {
    isCollapsed: state => state.isCollapsed
};

export default {
    state,
    mutations,
    getters
};